var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserStatus',_vm._b({staticClass:"status"},'UserStatus',_vm.row.status,false))}
var staticRenderFns = []

export { render, staticRenderFns }